// src/reducers/exampleReducer.js

import { SHOW_LOADER } from "../../../constants/action";

const initialState = {
  loading: false,
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default loaderReducer;
